import React, { useEffect, useState } from "react";
import BlogCard from "../componentes/BlogCard";
import articlesData from "../data/articles.json";

const Blog = () => {
  const [articles, setArticles] = useState([]);

  useEffect(() => {
    setArticles(articlesData);
  }, []);

  return (
    <section className="blog-container" aria-labelledby="blog-heading">
      {articles.length > 0 ? (
        articles.map((article) => <BlogCard key={article.id} {...article} />)
      ) : (
        <p>No articles available</p>
      )}
    </section>
  );
};

export default Blog;
